
const lib = 'HOWLER';

// TODO refactor
// 1. make audiomanger into global singleton
// 2. separate audio manager functions to audio engine functions -> create audio engine

let SelectedAudioManager = null;

if (lib === 'HOWLER') {
    cc.audioEngine = null;
    SelectedAudioManager = require('AudioManagerH');

    // overrides will be injected after cocos initializes the engine
    cc.game.once(cc.game.EVENT_ENGINE_INITED, () => {
        SelectedAudioManager.overrideCocosDownloader();
        SelectedAudioManager.injectHowlerOverrides();
    });
} else  {
    SelectedAudioManager = require('AudioManagerCC');
}

cc.Class({
    extends: SelectedAudioManager
});
